import { Component, computed, Inject, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MappingAndConfirmation } from '../../models/new-mapping';
export type DialogType = 'success' | 'error' | 'info' | 'warning';

export interface DialogData {
  header?: string;
  type?: DialogType;
  content?: string | MappingAndConfirmation[];
  confirm?: string;
  user?: string;
  viewType?: 'message' | 'grid';
  rowData?: any[];
  columnDefs?: any[];
  accept?: string;
  reject?: string;
  showAccept?: boolean;
  pagination?: boolean;
  showProceed?: boolean;
  proceedLabel?: string;
  cancelLabel?: string;
  secondaryActionLabel?: string;
  secondaryActionResult?: string;
}
@Component({
  selector: 'app-confirmation',
  imports: [CommonModule, MatIconModule],
  templateUrl: './confirmation.html',
  styleUrl: './confirmation.scss'
})
export class Confirmation {

  content = signal<string | MappingAndConfirmation[]>('');
  constructor(
    public dialogRef: MatDialogRef<Confirmation>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.content.set(this.data.content || '');
  }

  closeDialog() {
    this.dialogRef.close();
  }
  onProceed(): void {
    this.dialogRef.close('proceed');
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }

  onSecondaryAction(): void {
    this.dialogRef.close(this.data.secondaryActionResult || 'secondary');
  }

  readonly dialogType = computed<DialogType>(() => this.data.type || 'info');

  isString = computed(() => typeof this.content() === 'string');
  isArray = computed(() => Array.isArray(this.content()));
  textContent = computed(() => typeof this.content() === 'string' ? this.content() as string : '');
  tableContent = computed(() => Array.isArray(this.content()) ? this.content() as MappingAndConfirmation[] : []);

}
